import React from 'react'
import styles from "./style.scss"


export default function ShowComment({ mrp_status , mrp_rejected_reason }) {

    let mrp_status_description = {}

    switch (mrp_status) {
        case "REJECTED":
            mrp_status_description = {
                title: "Photo Proof of MRP Rejected",
                description:<span> Your uploaded photo proof of MRP has been rejected due to {mrp_rejected_reason || ''}.<br /><br />

                Mandated government regulation requires MRP to be verified before it can be showcased on the marketplace.</span>,
                type: "danger"
            }
            break;
        case "":
        case "IMAGES REQUIRED":
            mrp_status_description = {
                title: "Photo Proof of MRP Required",
                description: "Mandated government regulation requires MRP to be verified before it can be showcased on the marketplace.",
                type: "warning"
            }
            break;
                default:
            break;
    }

    return (
      <div className={`${styles["comment_blk"]} ${mrp_status_description.type}`}>
            {
                mrp_status_description?.description &&
                <div className={styles["comment"]}>
                    <div className={styles["comment_title"]}>
                        <span class={`icon-infoCircle ${styles["title_icon"]}`}></span>
                        {mrp_status_description.title}
                    </div>
                    <div className={styles["comment_description"]}>
                        {mrp_status_description.description}
                    </div>
                </div>
            }

        </div>
    )
}
